import './AddToTaskSelector.scss';
import { AntdOptionType } from '@sonar-software/sonar-ts-types';
import { caseInsensitiveContainsFilterOption } from '@lib/filter';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { Select } from 'antd';
import React, { useMemo } from 'react';
import { useCurrentUser, useInitiativeTasks, useLinkInitiativeTask } from '@hooks';

export interface AddToTaskSelectorProps {
	initiativeId: number;
	nameFilter?: string;
	onSelect: () => void;
	selectAllEnabled?: boolean;
	scopeIds?: Array<number>;
	sonarObjectIds?: Array<number>;
	typesFilter?: Array<string>;
}

export const AddToTaskSelector: React.FC<AddToTaskSelectorProps> = ({
	initiativeId,
	nameFilter,
	onSelect,
	selectAllEnabled,
	scopeIds,
	sonarObjectIds,
	typesFilter
}) => {
	const { isReadOnly } = useCurrentUser();
	const { tasks } = useInitiativeTasks(initiativeId);

	const { request } = useLinkInitiativeTask();

	const selectOptions: AntdOptionType[] = useMemo(
		() =>
			tasks?.map((task) => ({
				label: task.name,
				value: String(task.initiativeTaskId)
			})) ?? [],
		[ tasks ]
	);

	const handleOnSelect = (value: string) => {
		const taskId = Number(value);

		request({
			all: selectAllEnabled,
			initiativeId,
			initiativeScopeIds: selectAllEnabled ? [] : scopeIds,
			initiativeScopeIdsToExclude: selectAllEnabled ? scopeIds : [],
			initiativeTaskId: taskId,
			objectNameSearchText: nameFilter,
			objectTypes: typesFilter,
			sonarObjectIds: sonarObjectIds
		});

		onSelect();
	};

	return (
		<Select
			className='add-to-task-selector'
			defaultValue={ COPY_SPECIFIC.ADD_TO_TASK }
			disabled={ isReadOnly }
			filterOption={ caseInsensitiveContainsFilterOption }
			onSelect={ handleOnSelect }
			options={ selectOptions }
			showSearch
			value={ COPY_SPECIFIC.ADD_TO_TASK } />
	);
};
